import type { Summary } from "../../lib/types.ts";

/**
 * Reparto de estados de animo.
 *
 * Nueve categorias estan por encima del techo de una paleta categorica, asi
 * que la barra codifica magnitud con un solo tono y la identidad la llevan el
 * emoji y la etiqueta. El color del animo aparece solo como punto de apoyo.
 */
export function MoodBars({ distribution }: { distribution: Summary["moodDistribution"] }) {
  const total = distribution.reduce((sum, m) => sum + m.count, 0);
  if (total === 0) return <p className="empty">Aún no hay registros.</p>;

  const max = Math.max(...distribution.map((m) => m.count));

  return (
    <ul className="bars">
      {distribution.map((mood) => {
        const share = Math.round((mood.count / total) * 100);
        return (
          <li className="bars__row" key={mood.slug}>
            <span className="bars__label">
              <span aria-hidden="true">{mood.emoji}</span>
              {mood.label}
            </span>
            <span className="bars__track">
              <span
                className="bars__fill"
                style={{ width: `${(mood.count / max) * 100}%` }}
              />
            </span>
            <span className="bars__value">
              {mood.count}
              <span className="subtle"> · {share}%</span>
            </span>
          </li>
        );
      })}
    </ul>
  );
}
